<template>
  <SpaceSettingsEditModalTemplate @close="$emit('close')">
    <template v-slot:title>{{ $t('editTitle') }}</template>
    <template v-slot:form>
      <IncomeSettingsForm :edit_item="edit_income"
                          @cancelEdit="$emit('close')"/>
    </template>
  </SpaceSettingsEditModalTemplate>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import IncomeSettingsForm from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettingsForm";
import SpaceSettingsEditModalTemplate from "@/components/UI/SpaceSettings/SpaceSettingsEditModalTemplate";

export default {
  name: "IncomeSettingsEditModal",
  props: {
    edit_income: {
      type: Object
    }
  },
  components: {SpaceSettingsEditModalTemplate, IncomeSettingsForm, CustomModal},
  i18n: {
    messages: {
      en: {
        editTitle: 'Edit income source'
      },
      ru: {
        editTitle: 'Редактирование источника дохода'
      }
    }
  }
}
</script>